import React from 'react';

function QuestionCard({ question, currentAnswer, onAnswerChange }) {
    const isMultiple = question.has_multiple_correct_answers;

    const handleOptionToggle = (optionId) => {
        if (isMultiple) {
            // currentAnswer for multiple choice is comma-separated string or array
            let selected = [];
            if (currentAnswer) {
                selected = currentAnswer.split(',').filter(id => id.trim() !== '');
            }

            if (selected.includes(optionId.toString())) {
                selected = selected.filter(id => id !== optionId.toString());
            } else {
                selected.push(optionId.toString());
            }
            onAnswerChange(selected.join(','));
        } else {
            onAnswerChange(optionId.toString());
        }
    };

    return (
        <div className="question-card animate-in fade-in slide-in-from-bottom-4 duration-500">
            <div className="mb-lg">
                <span className="badge badge-secondary mb-sm">Question {question.order + 1}</span>
                <h3 className="text-xl font-bold leading-relaxed">{question.question_text}</h3>
                <p className="text-sm text-muted italic mt-xs">
                    {isMultiple ? 'Select all that apply' : 'Select one answer'} • {question.points} {question.points === 1 ? 'point' : 'points'}
                </p>
            </div>

            <div className="options-list flex flex-col gap-md">
                {question.options?.map((option) => {
                    const isSelected = isMultiple
                        ? currentAnswer?.split(',').includes(option.id.toString())
                        : currentAnswer === option.id.toString();

                    return (
                        <label
                            key={option.id}
                            className={`option-item p-md rounded-2xl border-2 transition-all cursor-pointer flex items-center gap-md ${isSelected
                                    ? 'border-primary bg-primary bg-opacity-5 ring-1 ring-primary ring-opacity-20'
                                    : 'border-theme-border hover:border-theme-border hover:bg-theme-bg'
                                }`}
                        >
                            <input
                                type={isMultiple ? "checkbox" : "radio"}
                                name={`question-${question.id}`}
                                checked={isSelected}
                                onChange={() => handleOptionToggle(option.id)}
                                className="w-5 h-5 accent-primary"
                            />
                            <span className="font-medium">{option.option_text}</span>
                        </label>
                    );
                })}
            </div>
        </div>
    );
}

export default QuestionCard;
